<template>
  <v-card tile id="swo">
    <v-card-title>
      <v-toolbar flat>
        <v-toolbar-title class="col-6">{{
          resx.labels.subjectsWithObligations
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-select
          class="company-filter"
          menu-props="left, offsetY"
          style="z-index: 100!important"
          :items="companies"
          :label="`${resx.labels.company}`"
          item-text="name"
          item-value="_id"
          v-model="filters.filterCompany"
          :no-data-text="resx.messages.noSelectorDataAvailable"
          :disabled="loading"
        />
      </v-toolbar>
    </v-card-title>
    <v-card-text class="table-container fixed-header">
      <v-row row class="count-items">
        <v-spacer></v-spacer>
        <v-col class="col-6"></v-col>
        <v-col shrink class="col-3">
          <span v-if="items.length > 0">{{
            `${resx.labels.contractors}: ${contractorCount}`
          }}</span>
        </v-col>
        <v-col shrink class="col-3">
          <span v-if="items.length > 0">{{
            `${resx.labels.swo + " " + resx.labels.total}: ${swoCount}`
          }}</span>
        </v-col>
      </v-row>
      <v-row column fill-height>
        <v-col fill-height class="scrollable">
          <v-data-table
            :class="{ 'layout-fixed': $vuetify.breakpoint.lgAndUp }"
            :headers="headers"
            :items="items"
            :loading=loading
            :no-data-text="resx.messages.noContractorsAvailable"
            :no-results-text="resx.messages.noContractorsFound"
            height="auto"
            sort-by="contractor.name"
            ref="dataTable"
            :items-per-page="itemsPerPage"
            :footer-props="{ itemsPerPageOptions: [15, 50, 100], itemsPerPageText: 'Mostrar' }"
            @update:items-per-page="saveItemsPerPage"
            loading-text=""
          >
          <template v-slot:loading>
            <BarLoader :isLoading=loading />
          </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import companyService from "@/services/CompanyService";
import contractorCompanyService from "@/services/ContractorCompanyService";
import BarLoader from "@/components/common/bar-loader.vue";

export default {
  components: {
    BarLoader
  },
  async mounted() {
    this.companies = await companyService.getCompanies(true);
    this.items = await contractorCompanyService.getSWO();
    this.loading = false;
  },
  data() {
    const resx = this.$store.state.locale.resx;
    return {
      headers: [
        {
          class: "hidden-sm-and-down",
          text: resx.labels.contractor,
          value: "contractor.name"
        },
        {
          class: "hidden-sm-and-down",
          text: resx.labels.identifierText,
          value: "contractor.identifier.number"
        },
        {
          class: "hidden-sm-and-down",
          text: resx.labels.contractorType,
          value: "type.name"
        },
        {
          class: "hidden-sm-and-down",
          text: resx.labels.swo,
          value: "swo",
          align: "center"
        },
        {
          class: "hidden",
          text: resx.labels.company,
          value: "company._id",
          filter: this.companyFilter
        }
      ],
      itemsPerPage: parseInt(localStorage.getItem(this.$options.name + '_itemsPerPage')) || 50,
      filters: {
        filterCompany: null
      },
      items: [],
      companies: [],
      loading: true
    };
  },
  methods: {
    saveItemsPerPage(val) {
      this.itemsPerPage = val;
      localStorage.setItem(this.$options.name + '_itemsPerPage', val);
    },
    companyFilter(companyId) {
      if (!this.filters.filterCompany) {
        return false;
      }
      return companyId == this.filters.filterCompany;
    }
  },
  computed: {
    contractorCount: function() {
      let currentItems = this.$refs.dataTable.internalCurrentItems;
      let count = Object.keys(currentItems).length;
      return count;
    },
    swoCount: function() {
      let currentItems = this.$refs.dataTable.internalCurrentItems;
      let count = 0;
      currentItems.forEach(item => {
        count += item.swo;
      });
      return count;
    }
  }
};
</script>

<style lang="scss">
#swo {
  .v-card {
    height: 100%;
  }

  .hidden {
    display: none;
  }

  .v-data-table td:nth-child(5) {
    display: none;
  }

  .v-card__text {
    font-size: 1.455rem;
    color: rgba(0, 0, 0, 1);
  }

  .company-filter .v-text-field__details {
    display: none;
  }
}
</style>
